export enum EGameType {
  NLH = 'NLH',
  PLO4 = 'PLO4',
  PLO5 = 'PLO5',
}
